import createWebIcon from "../createWebIcon";
import type { IconProps } from "../Icon.props";
import validateKeys from "../validateKeys";

export default function Clock({ outline, ...props }: IconProps): JSX.Element {
  return outline ? <Clock.Outline {...props} /> : <Clock.Solid {...props} />;
}

Clock.Outline = function Outline({ name, ...props }: IconProps) {
  const Icon = createWebIcon({
    ...props,
    name: `${name}Outline`,
    path: (
      <>
        <path
          d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z"
          stroke="currentColor"
          strokeWidth="1.5"
          fill="none"
          className="icon-outline"
        />
        <path
          d="M12 7V12L15 15"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
          fill="none"
          className="icon-outline"
        />
      </>
    ),
  });

  return <Icon {...validateKeys(props)} />;
};

Clock.Solid = function Solid({ name, ...props }: IconProps) {
  const Icon = createWebIcon({
    ...props,
    name: `${name}Solid`,
    path: (
      <>
        <path
          opacity="0.4"
          d="M22.5574 12.1433C22.5574 17.6673 18.0804 22.1433 12.5574 22.1433C7.0344 22.1433 2.5574 17.6673 2.5574 12.1433C2.5574 6.62131 7.0344 2.14331 12.5574 2.14331C18.0804 2.14331 22.5574 6.62131 22.5574 12.1433Z"
          className="icon-secondary"
        />
        <path
          d="M16.1311 15.9578C16.0001 15.9578 15.8681 15.9238 15.7471 15.8528L11.8211 13.5108C11.5951 13.3748 11.4561 13.1298 11.4561 12.8658V7.81885C11.4561 7.40485 11.7921 7.06885 12.2061 7.06885C12.6201 7.06885 12.9561 7.40485 12.9561 7.81885V12.4398L16.5161 14.5628C16.8711 14.7758 16.9881 15.2358 16.7761 15.5918C16.6351 15.8268 16.3861 15.9578 16.1311 15.9578Z"
          fill="currentColor"
          className="icon-primary"
        />
      </>
    ),
  });

  return <Icon {...validateKeys(props)} />;
};
